<script setup lang="ts">
import {ref} from 'vue'
import {useI18n} from "vue-i18n";

const props = defineProps({
  addNewCard: Boolean,
  cards: Array
});
const {t} = useI18n();
const emit = defineEmits(['update:selectedCard', 'addNewCardSelected']);

const selectedCard = ref(props.cards[0].id)
emit('update:selectedCard', props.cards[0].id)

watch(selectedCard, newValue => {
  if (newValue === 'new-card') {
    emit('addNewCardSelected');
  } else {
    emit('update:selectedCard', newValue)
  }
});
</script>


<template>

  <Select v-model="selectedCard">
    <SelectTrigger>
      <SelectValue :value="selectedCard"/>
    </SelectTrigger>
    <SelectContent class="w-full z-[99999]">
      <SelectGroup>
        <SelectItem v-for="(card, index) in cards" :key="index" :value="card.id">
          <div class="flex gap-4 h-14">
            <img class="object-contain" src="~assets/icons/visa.svg" alt="Card Image"/>
            <div class="flex gap-4 items-center justify-start">
              <span class="">{{ card.title }}</span>
            </div>
          </div>
        </SelectItem>
        <SelectItem v-if="addNewCard" :value="'new-card'">
          <div class="flex items-center font-semibold gap-4 p-3 pl-0">
               <span>
              <IconPlus size="21px"/>
            </span>
            <span>{{ t('cards.add_new') }}</span>
          </div>
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>
